module.exports = __webpack_public_path__ + "static/img/about-step2.a5b5ddbc.png";